import React from 'react';
import { Form, Input, Card, Alert, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';

interface OtpStepProps {
  phone: string;
  otpCode: string;
  password: string;
  loading: boolean;
  error: string | null;
  onOtpChange: (code: string) => void;
  onPasswordChange: (password: string) => void;
  onClearError: () => void;
}

const OtpStep: React.FC<OtpStepProps> = ({
  phone,
  otpCode,
  password,
  loading,
  error,
  onOtpChange,
  onPasswordChange,
  onClearError
}) => {
  const { t } = useTranslation();

  const handleOtpChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (error) onClearError();
    onOtpChange(e.target.value);
  };

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (error) onClearError();
    onPasswordChange(e.target.value);
  };

  return (
    <Card>
      <Alert
        message={t('telegram-otp-sent-title', { ns: 'standard' })}
        description={t('telegram-otp-sent-description', { ns: 'standard', phone })}
        type="info"
        showIcon
        style={{ marginBottom: 24 }}
      />
      
      <Row justify="center">
        <Col xs={24} sm={18} md={14} lg={10} xl={8}>
          <Form layout="vertical" disabled={loading}>
            <Form.Item
              label={t('telegram-otp-code', { ns: 'standard' })}
              name="otpCode"
              rules={[
                { required: true, message: t('field-required', { ns: 'validations' }) }
              ]}
              validateStatus={error ? 'error' : ''}
              help={error ? t(error, { ns: 'errors' }) : ''}
            >
              <Input
                value={otpCode}
                onChange={handleOtpChange}
                placeholder={t('telegram-otp-code-placeholder', { ns: 'standard' })}
                maxLength={6}
                style={{ textAlign: 'center', fontSize: '18px', letterSpacing: '0.5em' }}
              />
            </Form.Item>

            <Form.Item
              label={t('telegram-password', { ns: 'standard' })}
              name="password"
              help={t('telegram-password-help', { ns: 'standard' })}
            >
              <Input.Password
                value={password}
                onChange={handlePasswordChange}
                placeholder={t('telegram-password-placeholder', { ns: 'standard' })}
              />
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </Card>
  );
};

export default OtpStep;
